import './timeline.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { whenPageRevealed } from '@/js/lib/page-reveal.js';

gsap.registerPlugin( ScrollTrigger );

// Hoogte in beeld waarop de lijn "schrijft". Stip en tekst van een jaar komen
// op het moment dat het uiteinde van de lijn de stip bereikt.
const LINE_POSITION = '80%';

// Tijden en easing gelijk aan hero-reveal.js (data-hero-reveal-child). De kop
// animeert via highlight-reveal.js.
const FADE = { opacity: 1, y: 0, duration: 0.7, ease: 'power3.out' };

function hide( timeline ) {
	gsap.set( timeline.querySelector( '.o-timeline__introBody' ), { opacity: 0, y: 16 } );
	gsap.set( timeline.querySelector( '.o-timeline__list' ), { '--timeline-line': 0 } );
	gsap.set( timeline.querySelectorAll( '.o-timeline__marker' ), { scale: 0 } );
	gsap.set( timeline.querySelectorAll( '.o-timeline__year, .o-timeline__entryHeading, .o-timeline__entryText' ), { opacity: 0, y: 16 } );
	gsap.set( timeline.querySelectorAll( '.o-timeline__entryImage img' ), { opacity: 0, y: 24 } );
}

function reveal( timeline ) {
	const list    = timeline.querySelector( '.o-timeline__list' );
	const entries = [ ...timeline.querySelectorAll( '.o-timeline__entry' ) ];
	const intro   = timeline.querySelector( '.o-timeline__introBody' );

	// Trigger op de grid: de intro zelf is sticky.
	if ( intro ) {
		gsap.to( intro, {
			...FADE,
			delay:         0.2,
			scrollTrigger: {
				trigger: timeline.querySelector( '.o-timeline__inner' ),
				start:   'top 90%',
				once:    true,
			},
		} );
	}

	gsap.to( list, {
		'--timeline-line': 1,
		ease:              'none',
		scrollTrigger:     {
			trigger:    entries[ 0 ].querySelector( '.o-timeline__marker' ),
			start:      `center ${ LINE_POSITION }`,
			endTrigger: list,
			end:        `bottom ${ LINE_POSITION }`,
			scrub:      true,
		},
	} );

	entries.forEach( ( entry ) => {
		const marker = entry.querySelector( '.o-timeline__marker' );
		const text   = entry.querySelectorAll( '.o-timeline__year, .o-timeline__entryHeading, .o-timeline__entryText' );
		const image  = entry.querySelector( '.o-timeline__entryImage' );

		gsap.timeline( {
			scrollTrigger: {
				trigger: marker,
				start:   `center ${ LINE_POSITION }`,
				once:    true,
			},
		} )
			.to( marker, { scale: 1, duration: 0.5, ease: 'power3.out' }, 0 )
			.to( text, { ...FADE, stagger: 0.12 }, 0.05 );

		// Een foto staat vaak ver onder de tekst en krijgt een eigen moment.
		if ( image ) {
			gsap.to( image.querySelector( 'img' ), {
				...FADE,
				duration:      1.1,
				scrollTrigger: {
					trigger: image,
					start:   'top 90%',
					once:    true,
				},
			} );
		}
	} );
}

function init() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	const timelines = [ ...document.querySelectorAll( '.o-timeline' ) ].filter( ( timeline ) => timeline.querySelector( '.o-timeline__entry' ) );

	// Beginstand meteen, zodat er tijdens het wegschuiven van de loader niets
	// knippert. De triggers pas daarna: anders speelt alles achter de loader af.
	timelines.forEach( hide );
	whenPageRevealed().then( () => timelines.forEach( reveal ) );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
